<template>
  <g-card class="card-principal" :temCabecalho="false" :expansivel="false" paddingDefault="0">
    <div class="container-conteudo-carta-proposta-finalizada">
      <div class="container-cabecalho-carta-finalizada">
        <div class="cabecalho-carta-proposta">
          <div class="imagem-titulo-carta-proposta">
            <div class="imagem-carta-cabecalho">
              <img src="@/assets/imgs/icone_carta_menor.svg" class="img-carta"/>
            </div>
            
            <div class="titulo-carta-finalizada">
              <div class="titulo-codigo-resumo-final label"> 
                <div class="titulo-resumo-final"> CARTA-PROPOSTA </div>
                <div class="codigo-carta-finalizada">
                  <div class="hashtag titulo-resumo-final"> # </div>
                  <div class="numero-carta">{{this.codigoCarta}}</div>
                </div>
              </div>

              <div class="subtitulo-resumo-final"> SUA CARTA FOI CRIADA COM SUCESSO! </div>
            </div>
          </div>
        
          <div class="data-criacao">
            <div class="container-titulo-data-criacao"> 
              <div class="titulo-data-criacao"> Data de Criação </div>
              <div class="dois-pontos titulo-data-criacao">:</div>
            </div>

            <div class="label-data-criacao">{{ this.dataInclusao }}</div>
          </div>
        </div>

        <div class="buttons-nome-cliente">
          <div class="nome-input-cliente">
            <div class="label-nome-cliente"> Nome do Cliente </div>
            <g-form class="formulario-nome-cliente">
              <PInputText
              v-model="inputNomeCliente"
              class="input-nome-cliente"
              placeholder="Adicione o nome que será utilizado na Carta-Proposta"
              ></PInputText>
            </g-form>
          </div>

          <div class="botoes-desk" v-if="!isLoadingPdf">
            <div class="botao-compartilhardesk">
              <g-button
                altura="35px"
                largura="35px"
                tamanhoIcone="18px"
                class="button-compartilhar-copia"
                icone="icone_compartilhar.svg"
              >
              </g-button>
            </div>

            <div class="botao-imprimirdesk">
              <g-button
                altura="35px"
                largura="35px"
                tamanhoIcone="18px"
                class="button-compartilhar-copia"
                icone="icone_print.svg"
                v-on:acao="abrirPDF"
                v-tooltip="'Abrir PDF'"
             
              >
              </g-button>
            </div>

            <div class="botao-compartilhardesk">
              <g-button
                altura="35px"
                largura="35px"
                tamanhoIcone="18px"
                class="button-compartilhar-copia"
                icone="pi pi-download"
                corIconeClass="4f2c19"
                v-tooltip="'Baixar PDF'"
                @click="baixarPDF"
         
              >
              </g-button>
            </div>
          </div>
          <div  v-else>
            <i class="pi pi-spin pi-spinner"></i>
          </div>
        </div>
      </div>

      <div 
        class="carta-finalizada"
        v-for="(orcamentoInformacao, indexOrc) in this.orcamentosInformacoes"
        :key="indexOrc"
      >
        <div class="conteudo-carta-finalizada">
          <div class="informacoes-orcamento">
            <div class="data-imagem-carta" v-if="indexOrc === 0">            
              <div class="imagem-logo-jauense">
                <img class="img-logo" src="@/assets/imgs/grupo_jauense_logo.svg"/>
              </div>

              <div class="data-carta-proposta titulo-conteudo-detalhes"> Jaú, {{ this.DiaHoje }} </div>
            </div>

            <div class="titulo-referencia-nome-cliente" v-if="indexOrc === 0">
              <div class="label-conteudo"> À <br> {{ cartaPropostaArray.nomeCliente }} </div>
            </div>

            <div class="info-cliente" v-if="indexOrc === 0">
              <div class="cliente descricao-cliente">
                <div class="titulo-conteudo-detalhes"> A/Sr(a): </div>
                <div class="nome-cliente titulo-conteudo-detalhes">
                  {{
                    inputNomeCliente == "" ? "Nome do Cliente" : inputNomeCliente
                  }}
                </div>
              </div>

              <div class="referente descricao-cliente">
                <div class="titulo-conteudo-detalhes"> Referente: </div>
                <div class="nome-referente label-conteudo"> Nome do Cliente </div>
              </div>
              
              <div class="unidade descricao-cliente">
                <div class="titulo-conteudo-detalhes"> Unidade: </div>
                <div class="nome-unidade label-conteudo">{{ cartaPropostaArray.nomeEmpresa }}</div>
              </div>
            </div>
            
            <div class="mensagem-carta" v-if="indexOrc === 0">
              <div class="label-conteudo"> Prezado(a) Senhor(a), </div>
              <div class="mensagem label-conteudo"> Conforme solicitado, seguem abaixo preços e condições para fornecimento, a saber </div>
            </div>

            <div class="info-produto-orcamento">
              <div class="conteudo-info-prod-orcamento">
                <div class="container-info-produto">
                  <div class="section-produto">
                    <div class="imagem-info-produto">
                      <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-orcamento">
                    </div>
                    
                    <div class="info-produto">
                      <div class="nome-produto label">
                        <div class="titulo-conteudo-detalhes titulo-conteudo-orcamento"> Nome do {{indexOrc + 1}}º Produto: </div>                  
                        <div class="label-conteudo">{{orcamentoInformacao.nomeProduto}}</div>
                      </div>
                      
                      <div class="orcamento label">
                        <div class="titulo-conteudo-detalhes titulo-conteudo-orcamento"> Orçamento: </div> 
                        <div class="label-conteudo">{{orcamentoInformacao.codigoOrcamento}}</div>
                      </div>
                      
                      <div class="opcao label">
                        <div class="titulo-conteudo-detalhes titulo-conteudo-orcamento"> Opção: </div>                  
                        <div class="label-conteudo">{{orcamentoInformacao.descricaoOpcao ? orcamentoInformacao.descricaoOpcao : 'Não cadastrado'}}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-for="(comp, indexOrcComp) in orcamentoInformacao.orcamentoComponentes"
                    :key="indexOrcComp"
                  >
                    <div class="frete label">
                      <div class="titulo-conteudo-detalhes titulo-conteudo-orcamento"> Frete: </div>
                      <div class="label-conteudo">{{ comp.indicadorDeTipoFreteText }}</div>
                    </div>
                  </div>
                </div>

                <div class="orcamento-tabela">
                  <div class="cabecalho-tabela">
                    <div class="titulo-conteudo-detalhes titulo-tabela"> Quantidade </div>
                    <div class="titulo-conteudo-detalhes titulo-tabela"> Preço </div>
                  </div>
                  
                  <div 
                    class="informacao-tabela" 
                    v-for="(orcamentoData, indexOrcData) in orcamentoInformacao.orcamentoDatas"
                    :key="indexOrcData"
                  >
                    <div class="label-conteudo label-tabela">{{ orcamentoData.quantidadeFormatada }}</div>
                    <div class="label-conteudo label-tabela"> R$ {{ orcamentoData.valorPrecoIdealFormatado }}</div>
                  </div>
                </div>                            
              </div>
            </div>
          </div>

          <div class="container-componentes" v-if="orcamentoInformacao.componentes.length > 0">
            <div class="titulo-grupo-detalhes titulo-componentes"> Composição Técnica </div>
            <div class="content-componentes">
              <div 
                class="box-componente"
                v-for="(data, indexComp) in orcamentoInformacao.componentes"
                :key="indexComp"
              > 
                <div class="imagem-numero-nome-componente">
                  <div class="imagem-grupo-componente">
                    <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                  </div>
                  
                  <div class="numero-nome-componente">
                    <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ indexComp + 1 }}</div>
                    <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                  </div>
                </div> 

                <div class="grupo-componentes">
                  <div class="componentes-medidas">
                    <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                    <div class="medidas label-conteudo">
                      {{
                        (data.numeroComprimento != 0) && (data.numeroLargura != 0)  ? data.numeroComprimento + 'x' + data.numeroLargura + 'x' + data.numeroAltura + 'x' + data.numeroAlturaTampa : data.descricaoMedidasTexto
                      }}
                    </div>
                  </div>

                  <div class="componentes-cor-frente">
                    <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                    <div class="corFrente label-conteudo">{{ data.quantidadeCoresFrente }} Cor(es)</div>
                  </div>

                  <div class="componentes-cor-verso">
                    <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                    <div class="corVerso label-conteudo">{{ data.quantidadeCoresVerso }} Cor(es)</div>
                  </div>

                  <div class="componentes-acabFrente">
                    <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                    <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
                  </div>

                  <div class="componentes-acabVerso">
                    <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                    <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto  }}</div>
                  </div>

                  <div class="componentes-material">
                    <div class="material titulo-conteudo-detalhes"> Material </div>
                    <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
                  </div>

                  <div class="componentes-onda">
                    <div class="onda titulo-conteudo-detalhes"> Onda </div>
                    <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
                  </div>

                  <div class="componentes-capaExt">
                    <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                    <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
                  </div>

                  <div class="componentes-gramaturaExt">
                    <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura </div>
                    <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
                  </div>

                  <div class="componentes-capaInt">
                    <div class="capaInt titulo-conteudo-detalhes">  Papel de Onda</div>
                    <div class="capaInt label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
                  </div>

                  <div class="componentes-gramaturaInt">
                    <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura </div>
                    <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
                  </div>

                  <div class="componentes-papelOnda">
                    <div class="papelOnda titulo-conteudo-detalhes"> Capa Interna  </div>
                    <div class="papelOnda label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
                  </div>

                  <div class="componentes-gramaturaPO">
                    <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura </div>
                    <div class="gramaturaPO label-conteudo">{{ data.numeroGramaturaCapaInterna }}</div>
                  </div>

                  <!-- <div class="componentes-codigo" v-if="data.descricaoSistema == 0">
                    <div class="codigo-componente titulo-conteudo-detalhes"> Código </div>
                    <div class="label-conteudo">{{ data.codigoSistema }}</div>
                  </div> -->

                  <div class="componentes-descricao" v-if="data.descricaoSistema == 0">
                    <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                    <div class="label-conteudo">{{ data.sistema }}</div>
                  </div>

                  <div class="componentes-produto" v-if="data.descricaoSistema == 2">
                    <div class="produto-comp titulo-conteudo-detalhes"> Produto </div>
                    <div class="label-conteudo">{{ data.produtoSistema }}</div>
                  </div>

                  <div class="componentes-prototipo" v-if="data.descricaoSistema == 3">
                    <div class="prototipo titulo-conteudo-detalhes"> Protótipo </div>
                    <div class="label-conteudo">{{ data.prototipoSistema }}</div>
                  </div>

                  <div class="componentes-prototipo" v-if="data.descricaoSistema == 4">
                    <div class="prototipo titulo-conteudo-detalhes"> Conforme Planta </div>
                    <!-- <div class="label-conteudo">{{ data.prototipoSistema }}</div> -->
                  </div>

                  <div class="componentes-prototipo" v-if="data.descricaoSistema == 5">
                    <div class="prototipo titulo-conteudo-detalhes"> Conforme Arquivo Digital </div>
                    <!-- <div class="label-conteudo">{{ data.prototipoSistema }}</div> -->
                  </div>

                  <div class="componentes-embalagem-coletiva" 
                    v-if="data.embalagens != 0 || data.quantidadeOutros != 0"
                  >
                    <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                    <div class="labels-embalagem-coletiva">
                      <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                      >{{ texto }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container-observacao-orcamento">
            <div class="titulo-grupo-detalhes titulo-observacao-orcamento"> Observações sobre o Orçamento </div>
            <div class="content-observacao-orcamento content">
              <div class="icms">
                <div class="titulo-conteudo-detalhes"> Obs. sobre Quantidade / Carregamento / Consumo </div>
                <div class="label-conteudo">{{ orcamentoInformacao.observacaoProduto ? orcamentoInformacao.observacaoProduto : "Não possui observação." }}</div>
              </div>              
            </div>
          </div>

          <div class="container-consideracoes-gerais">
            <div class="titulo-grupo-detalhes titulo-consideracoes-gerais"> Considerações Gerais </div>
            <div class="content-consideracoes-gerais content">
              <div class="forma-pagto">
                <div class="titulo-conteudo-detalhes"> Cond. de Pagamento </div>
                <div class="label-conteudo">{{ this.formaDePagamento }}</div>
              </div>
            </div>
          </div>

          <div class="container-tributacoes">
            <div class="titulo-grupo-detalhes titulo-tributacoes"> Tributações </div>
            <div class="content-tributacoes content">
              <div class="icms">
                <div class="titulo-conteudo-detalhes"> ICMS </div>
                <div class="label-conteudo">
                  {{ this.valoricms !== 0 ? 'Incluso - '+ this.valoricms + '%' : 'Diferido'}}
                </div>
              </div>
              
              <div class="pis-confins">
                <div class="titulo-conteudo-detalhes"> PIS / COFINS </div>
                <div class="label-conteudo">
                  {{ this.valorpiscofins !== 0 ? 'Incluso - '+ this.valorpiscofins + '%' : 'Diferido'}}
                </div>
              </div>

              <div class="ipi">
                <div class="titulo-conteudo-detalhes"> IPI </div>
                <div class="label-conteudo">
                  {{ this.valoripi == 0 ? 'Não Incluso – Preço acima + IPI' : 'Diferido'}}
                  
                </div>
              </div>
            </div>
          </div>

          <div class="container-composicao-cartaProp" v-if="indexOrc + 1 === orcamentosInformacoes.length">
            <div class="titulo-grupo-detalhes titulo-composicao-cartaProp"> Composição da Carta-proposta </div>
            <div class="content-composicao-cartaProp content">
              <div class="label-conteudo"> Possível suspensão ou diferimento dependerá da apresentação da declaração expressa, nos termos da legislação vigente. </div>
              <div class="label-conteudo">{{ cartaPropostaArray.observacaoGeral ? cartaPropostaArray.observacaoGeral : " " }}</div>

              <div class="observacao-negociacao">
                <div class="label-conteudo label-obs-negoc">
                  <div class="titulo-conteudo-detalhes"> Observações da Negociação </div>
                  - De acordo com Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos. 
                </div>
              </div>

              <div 
                class="validade-proposta"
                v-for="(orcamentoInformacao, indexObs) in this.orcamentosInformacoes" 
                :key="indexObs"
              >
                <div class="data-validade-prop" v-if="indexObs === 0"> 
                  <div class="titulo-conteudo-detalhes titulo-validade"> Validade da Proposta: </div>
                  <div class="dias-validade"> 10 dias. </div>
                </div>

                <div class="label-conteudo" v-if="indexObs === 0"> - {{ orcamentoInformacao.observacaoNegociacao ? orcamentoInformacao.observacaoNegociacao : "Não possui observação." }} </div>
              </div>

              <div class="msg-final-doc"><div class="label-sem-mais"> Sem mais para o momento, </div> Nos colocamos a vosso dispor. </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-botoes">
        <g-button
          tamanhoTexto="15px"
          negritoTexto
          @click="novaCarta"
          class="button-continuar"
        > 
          NOVA CARTA 
        </g-button>
        <g-button
          tamanhoTexto="15px"
          negritoTexto
          tipo="cinza"
          @click="Continuar"
          class="button-ver-cartas"
        > 
          VER CARTAS 
        </g-button>
      </div>
    </div>
  </g-card>
  <PdfCartaPropostaComComponentes 
    v-if="renderiza && cartaPropostaTipo === 0"
    :cartaPropostaId = "CartaPropostaId"
    :nomeClientePersonalizado="inputNomeClientefinal" 
    :openPdfNewTab="abrePdf"
    :canDownloadPdf="podeBaixarPdf"
    :key="renderizaKey"
    @isLoading="isLoadingPdf = $event"
  />

  <PdfCartaPropostaSemComponentes
        v-else-if="renderiza"
        :cartaPropostaId = "CartaPropostaId"
        :nomeClientePersonalizado="inputNomeClientefinal" 
        :openPdfNewTab="abrePdf"
        :canDownloadPdf="podeBaixarPdf"
        :key="renderizaKey + 1"
        @isLoading="isLoadingPdf = $event"
        
    />

  
</template>

<script>

import GerarCartaPropostaFinalizado from "./GerarCartaPropostaFinalizado.js";
export default GerarCartaPropostaFinalizado;
</script>

<style scoped>
.container-conteudo-carta-proposta-finalizada div {
  font-family: 'MontSerrat';
}

.cliente .nome-cliente {
  color: #4f2c19 !important;
  margin: 0 0 0.2rem;
}
.titulo-conteudo-detalhes {
  color: #3f3f3f !important;
  margin: 0;
}
.label-conteudo {
  margin: 0 0 0.2rem;
}

.label {
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.5rem;
}

.container-cabecalho-carta-finalizada {
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
}

.imagem-carta-cabecalho {
  display: flex;
}

.img-carta {
  height: 4.5rem;
}

.titulo-carta-finalizada {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.codigo-carta-finalizada {
  display: flex;
  flex-wrap: nowrap;
  column-gap: 0.1rem;
}

.subtitulo-resumo-final {
  color: #707070;
  font-size: 18px;
  display: flex;
  flex-wrap: nowrap;
  column-gap: 0.8rem;
}

.container-numero {
  display: flex;
  flex-wrap: nowrap;
  column-gap: 0.1rem;
}

.numero-carta {
  color: #fcb316;
  font-size: 1.5rem;
  font-family: "MontSerrat";
  font-weight: 700;
}

.data-criacao {
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.5rem;
}

.container-titulo-data-criacao {
  display: flex;
  justify-content: flex-end;
}

.titulo-data-criacao, .label-data-criacao {
  width: max-content;
  color: #707070;
  font-size: 1rem;
  font-family: 'MontSerrat';
}

.titulo-data-criacao {
  width: max-content;
  font-weight: 600;
  display: flex;
}

.label-nome-cliente {
  color: #8a8a8a;
  width: fit-content;
  font-family: 'Montserrat';
  margin-bottom: 0.5rem;
  text-align: right;
}

.nome-input-cliente {
  width: 100%;
  max-width: 26rem;
}

.botoes-desk {
  display: flex;
  align-items: flex-end;
  column-gap: 0.5rem;
  justify-content: flex-end;
}

.carta-finalizada {
  width: 100%;
}

.conteudo-carta-finalizada {
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
}

.informacoes-orcamento, .conteudo-info-prod-orcamento {
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
}

.data-carta-proposta {
  color: rgb(54, 54, 54) !important;
  font-size: 1.25rem;
}

.imagem-logo-jauense {
  display: flex;
  align-items: center;
}

.titulo-referencia-nome-cliente {
  text-align: left;  
}

.descricao-cliente {
  display: flex;
  column-gap: 0.4rem;
}

.nome-cliente {
  text-decoration: underline;
}

.section-produto {
  max-width: max-content;
  background-color: #F9F9F9;
  border-radius: 0.5rem;
  display: flex;
  column-gap: 2rem;
  border-left: 5px solid #fcb31698;
  border-bottom: 5px solid #fcb31698;
}

.img-orcamento {
  height: 4rem;
}

.titulo-conteudo-orcamento {
  display: flex;
  column-gap: 0.5rem;
}

.titulo-conteudo-orcamento div {
  font-weight: 500;
}

.orcamento-tabela {
  width: 15rem;
}

.cabecalho-tabela, .informacao-tabela {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-content: center;
  column-gap: 0.5rem;
}

.label-tabela {
  padding-left: 0.1rem;
}

/* COMPONENTES */
.content-componentes {
  width: 100%;
  display: grid;
  gap: 1.5rem;
}
.box-componente {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.5rem 0.5rem;
  border-radius: 0.5rem;
}

.titulo-componentes {
  margin-bottom: 1.5rem;
}

.img-componente {
  height: 2.8rem;
  width: auto;
}

.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19 !important;
  font-size: 1rem !important;
}

.grupo-componentes .label-conteudo {
  margin-bottom: 10px;
}

.componentes-observacao-produto {
  grid-column: span 2;
}
/* FIM COMPONENTES */

.content {
  padding-top: 1rem;
}

.content-tributacoes {
  display: flex;
  flex-wrap: wrap;
  column-gap: 3rem;
  row-gap: 1rem;
}

.content-composicao-cartaProp .label-conteudo {
  text-align: justify !important;
}

.label-obs-negoc {
  display: flex;
  flex-direction: column;
  row-gap: 0.4rem;
}

.img-obs-negociacao {
  height: 2.5rem;
}

.data-validade-prop {
  display: flex;
  flex-wrap: wrap;
  column-gap: 0.5rem;
  padding-bottom: 0.3rem;
}

.validade-proposta {
  margin-top: 2rem;
}

.titulo-validade {
  color: #4f2c19 !important;
  font-size: 1rem;
}

.observacao-negociacao {
  margin-top: 2rem;
}

.dias-validade {
  color: #4f2c19;
  font-weight: 500;
}

.msg-final-doc {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 3rem;
}
.label-sem-mais {
  color: #3f3f3f;
  font-weight: 600;
}

.container-botoes {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 50px;
  row-gap: 15px;
  margin-top: 50px;
}

@media (min-width: 310px) {
  .container-conteudo-carta-proposta-finalizada {
    position: relative;
    display: flex;
    flex-direction: column;
    row-gap: 2.2rem;
    padding: 2rem 1.5rem;
  }

  .carta-finalizada {
    padding: 2.5rem 0 2rem;
    border-top: 1px solid #D5D5D5;
    border-bottom: 1px solid #D5D5D5;
  }

  .imagem-titulo-carta-proposta {
    width: 100%;
    justify-content: center;
    display: grid;
    grid-template-rows: max-content auto;
    row-gap: 1rem;
  }

  .titulo-codigo-resumo-final, .titulo-resumo-final, .subtitulo-resumo-final {
    text-align: center;
    justify-content: center;
  }

  .cabecalho-carta-proposta {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 2rem;
  }

  .data-criacao {
    justify-content: center;
  }

  .box-componente {
    row-gap: 1.2rem;
  }

  .imagem-numero-nome-componente {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .numero-nome-componente {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .section-produto {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 1.5rem;
    padding: 1.5rem 1rem 1rem;
  }

  .botoes-desk {
    margin-top: 2rem;
  }

  .data-imagem-carta {
    display: flex;
    flex-direction: column;
    row-gap: 2rem;
    align-items: center;
  }

  .observacao-negociacao {
    padding: 1rem 0;
  }
}

@media (min-width: 368px) {
  
}

@media (min-width: 500px) {
  .box-componente {
    row-gap: 0.8rem;
  }

  .imagem-numero-nome-componente {
    flex-direction: row;
  }

  .numero-nome-componente {
    align-items: flex-start;
  }

  .box-componente .grupo-componentes {
    display: grid;
    grid-template-columns: repeat(2, minmax(4rem, 1fr));
    grid-auto-rows: auto;
    grid-column-gap: 1rem;
  }
  .componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
  .componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
  .componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
  .componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
  .componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
  .componentes-material { grid-area: 4 / 1 / 5 / 2; }
  .componentes-onda { grid-area: 4 / 2 / 5 / 3; }
  .componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
  .componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
  .componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
  .componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
  .componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
  .componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }

  .imagem-obs-negociacao {
    justify-content: flex-start;
  }
}

@media (min-width: 600px) {
  .carta-finalizada {
    padding: 2.5rem 2.5rem 1.5rem 2rem;
    border-radius: 0.5rem;
    border: 1px solid #D5D5D5;
  }

  .buttons-nome-cliente {
    display: flex;
    justify-content: space-between;
    column-gap: 2rem;
    row-gap: 1rem;
    align-items: center;
  }

  .botoes-desk {
    margin-top: 2rem;
  }
}

@media (min-width: 700px) {
  .data-imagem-carta {
    flex-direction: row-reverse;
    justify-content: space-between;
    padding-right: 1rem;
  }

  .container-cabecalho-carta-finalizada {
    row-gap: 2rem;
  }

  .titulo-resumo-final, .subtitulo-resumo-final {
    width: max-content;
  }

  .titulo-codigo-resumo-final, .titulo-resumo-final, .subtitulo-resumo-final {
    text-align: left;
    justify-content: left;
  }

  .imagem-titulo-carta-proposta {
    justify-content: flex-start;
    grid-template-columns: max-content auto;
    column-gap: 1.5rem;
  }

  .section-produto {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    row-gap: 2rem;
    padding: 1.5rem 2rem 1rem;
  }
}

@media (min-width: 768px) {
  .container-botoes {
    flex-direction: row-reverse;
  }
}

@media (min-width: 801px) {
  .cabecalho-carta-proposta {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .dois-pontos {
    display: none;
  }
}

@media (min-width: 1025px) {
  .container-conteudo-carta-proposta-finalizada {
    padding: 2rem 3rem;
  }

  .cabecalho-carta-proposta {
    display: flex;
    justify-content: space-between;
  }

  .content-componentes {
    grid-template-columns: repeat(2, minmax(2rem, 1fr));
    column-gap: 1.5rem;
  }

  .data-criacao {
    flex-direction: column;
    justify-content: flex-end;
  }

  .observacao-negociacao {
    width: max-content;
    background-color: #F9F9F9;
    padding: 1rem;
    border-radius: 0.5rem;
  }
}

@media (min-width: 1281px) {
  .content-componentes {
    grid-template-columns: repeat(3, minmax(2rem, 1fr));
    column-gap: 1.5rem;
  }

  .imagem-numero-nome-componente, .grupo-componentes {
    padding: 0;
  }
}

@media (min-width: 1500px) {
  .container-conteudo-carta-proposta-finalizada {
    padding: 3rem 8rem;
  }
}
</style>


